import React, { memo } from 'react';

import cls from './InventoryCard.module.css';
import placeholderImage from '../../../../../assets/icons/placeholder-preview.svg';

interface InventoryImageProps {
    image: string;
}

export const InventoryImage = memo(({ image }: InventoryImageProps) => (
    <div className={cls.inventoryImageWrapper}>
        <img
            src={image || (placeholderImage as unknown as string)}
            className={cls.inventoryImage}
            alt="inventory-photo"
            draggable="false"
        />
    </div>
));
